const back = {}

export const root_path = () => '/'
back[root_path()] = () => root_path()

export const terms_path = () => '/terms'
back[terms_path()] = () => terms_path()

export const recovery_password_path = () => '/recovery_password'
back[recovery_password_path()] = () => root_path()

export const login_path = () => '/login'
back[login_path()] = () => login_path()

export const campaigns_path = () => '/campaigns'
back[campaigns_path()] = () => campaigns_path()

export const campaign_path = ({ id } = { id: ':id' }) => `/campaigns/${id}`
back[campaign_path()] = () => campaigns_path()

export const mission_path = (campaign = { id: ':campaign_id' }, { id } = { id: ':id' }) =>
  `${campaign_path(campaign)}/missions/${id}`
back[mission_path({ id: ':id' })] = params => campaign_path({ id: params[0] }, { id: params[1] })

export const mission_review_path = (campaign = { id: ':campaign_id' }, { id } = { id: ':id' }) =>
  `${campaign_path(campaign)}/missions/${id}/review`
back[mission_review_path({ id: ':id' })] = params => campaign_path({ id: params[0] }, { id: params[1] })

export const mission_finished_path = (campaign = { id: ':campaign_id' }, { id } = { id: ':id' }) =>
  `${campaign_path(campaign)}/missions/${id}/finished`
back[mission_finished_path({ id: ':id' })] = params =>
  campaign_path({ id: params[0] }, { id: params[1] })

export const edit_profile_path = () => '/edit_profile'
back[edit_profile_path()] = () => campaigns_path()

export const user_not_found_path = ({ email } = { email: ':email' }) =>
  `/user_not_found/${email}`
back[user_not_found_path()] = () => campaigns_path()

export const contact_path = () => '/contact'
back[contact_path()] = () => campaigns_path()

export const back_path = (route, params) => back[route](params)



// WEBPACK FOOTER //
// ./src/routes.jsx